<template>
  <User state="new" />
</template>

<script>
import User from '@/components/Settings/UserOperations/User'
export default {
    components: {
        User
    },
    data() {
      return {
        asdasd:''
      }
    },
    created() {
      console.log(this);
    }
}
</script>

<style>

</style>